import { motion } from "framer-motion";
// Styles
import Styles from "./BookCartForCart.module.css";
// Images
import image from "../../../../Assets/Images/bookImage.png";
import convertNumbersToPersian from "../../../../Utils/convertNumbersToPersian";

const BookCartForCart = ({
  index,
  handleAddToCard,
  price,
  name,
  writer,
  _id,
  image,
}) => {
  return (
    // <div className={Styles.container}>
    //   <img src={image} alt="" />
    // </div>
    <motion.div
      initial={{ x: -1500 }}
      animate={{ x: 0 }}
      transition={{ duration: 1, delay: index * 0.2 }}
      className={Styles.container}
    >
      <img
        src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${image}`}
        alt=""
      />
      <div className={Styles.detailsContainer}>
        <div className={Styles.infoContainer}>
          <div className={Styles.title}>{name}</div>
          <div className={Styles.writer}>{writer}</div>
        </div>
        <div className={Styles.priceContainer}>
          <div className={Styles.price}>
            {convertNumbersToPersian(price.toLocaleString())} تومان
          </div>
          <button
            onClick={() =>
              handleAddToCard({ price, id: _id, kind: "book", text: name })
            }
          >
            افزودن به سبد خرید
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default BookCartForCart;
